import { type Menu } from '@/models/Menu';
import MenuUrls from '@/services/urls/menu.url';
import api from '@/services/api/baseApi';
import type { ApiResponse } from '@/models/common/ApiResponse';
import type { MenuAndChildParent } from '@/models/common/MenuChildAndParent';
import type { Option } from '@ids/react-hook-form';

export const useMenuApi = () => {
  const fetchMenus = async (languageId: number, locationCode: string): Promise<Menu[]> => {
    const response: ApiResponse<Menu[]> = await api.get(
      `${MenuUrls.WebsiteMenusByLocation}${locationCode}`,
      { params: { languageId } },
    );
    return response.data.body;
  };

  const fetchMenusByParent = async (languageId: number, parentId: number): Promise<Menu> => {
    const response: ApiResponse<Menu> = await api.get(
      `${MenuUrls.WebsiteMenusByParent}${parentId}`,
      { params: { languageId } },
    );
    return response.data.body;
  };

  const fetchMenusByParentAndCategory = async (
    languageId: number,
    parentId: number,
    categoryId: number,
  ): Promise<Menu[]> => {
    const response: ApiResponse<Menu[]> = await api.get(
      `${MenuUrls.WebsiteMenusByParentAndCategory}${parentId}/${categoryId}`,
      { params: { languageId } },
    );
    return response.data.body;
  };

  const fetchChildAndParentMenuBySettingAndMeuTypeCodes = async (
    settingCode: string,
  ): Promise<MenuAndChildParent> => {
    const response: ApiResponse<MenuAndChildParent> = await api.get(
      MenuUrls.WebsiteMenuChildAndParent,
      { params: { settingCode } },
    );
    return response.data.body;
  };

  const fetchParentMenus = async (languageId: number): Promise<Option[]> => {
    const response: ApiResponse<Option[]> = await api.get(`${MenuUrls.ParentMenus}`, {
      params: { languageId },
    });
    return response.data.body;
  };

  return {
    fetchMenus,
    fetchMenusByParent,
    fetchChildAndParentMenuBySettingAndMeuTypeCodes,
    fetchMenusByParentAndCategory,
    fetchParentMenus,
  };
};
